import { COLORS } from 'styles/globals';
import { ThemeConfigType } from './theme';

export const defaultThemeColors = {
  gray01: COLORS.gray01,
  gray02: COLORS.gray02,
  gray03: COLORS.gray03,
  gray06: COLORS.gray06,
  gray07: COLORS.gray07,
  gray12: COLORS.gray12,
  gray13: COLORS.gray13,
  gray14: COLORS.gray14,
  grayLight: COLORS.grayLight,
  grayInactive: COLORS.grayInactive,

  brand01: COLORS.brand01,
  brand02: COLORS.brand02,
  brand02Hover: COLORS.brand02Hover,
  brand03: COLORS.brand03,
  brand04: COLORS.brand04,
  brand05: COLORS.brand05,
  brand06: COLORS.brand06,
  brand07: COLORS.brand07,
  brand08: COLORS.brand08,

  brand02Light: COLORS.brand02Light,
  brand04Light: COLORS.brand04Light,
  brand05Light: COLORS.brand05Light,
  brand06Light: COLORS.brand06Light,
  brand07Light: COLORS.brand07Light,

  errors: COLORS.errors,
  errorsLight: COLORS.errorsLight,
  warning: COLORS.warning,
  breadcumpColor: COLORS.gray03,
  buttonHover: COLORS.buttonHover,

  textColor01: COLORS.textColor01,
  textColor02: COLORS.textColor02,
  textColor03: COLORS.textColor03,
  textColor04: COLORS.textColor04,
  textColor05: COLORS.textColor05,
  textColor06: COLORS.textColor06,
  textColor07: COLORS.textColor07,
  textColor08: COLORS.textColor08,
  textColor09: COLORS.textColor09,
  textColor10: COLORS.gray01,
  textColor11: COLORS.textColor11,
  textColor12: COLORS.brand02,
  textColor13: COLORS.paleSky,

  button01: COLORS.button01,
  button02: COLORS.button02,

  switchColor01: COLORS.switchColor01,
  switchColor02: COLORS.switchColor02,
  switchColor03: COLORS.switchColor03,
  switchColor04: COLORS.switchColor04,

  boxShadow: COLORS.boxShadow,

  placeholder: COLORS.placeholder,
  rowSelectBackground: COLORS.rowSelectBackground,
  checkedCheckboxBackground: COLORS.brand02,

  iconColor01: COLORS.iconColor01,
  iconColor02: COLORS.iconColor02,
  iconColor03: COLORS.iconColor03,
  iconColor04: COLORS.iconColor04,
  iconColor05: COLORS.iconColor05,
  iconColor06: COLORS.iconColor06,
  iconColor07: COLORS.iconColor07,
  iconColor08: COLORS.gray04,
  iconColor09: COLORS.paleSky,
  iconColor10: COLORS.brand02,

  tableHeaderColor: COLORS.tableHeaderColor,

  disabledText: COLORS.disabledText,
  disabledBorder: COLORS.disabledBorder,
  disabledBackground: COLORS.disabledBackground,
  disabledBgForSelect: COLORS.disabledBgForSelect,
  selectOptionColor: COLORS.selectOptionColor,

  portalBackground: COLORS.portalBackground,
  componentsBackground: COLORS.componentsBackground,

  darkModeBorder: COLORS.darkModeBorder,

  border: COLORS.border,
  border2: COLORS.border2,
  border3: COLORS.border3,
  border4: COLORS.border4,
  border5: COLORS.border5,
  customBorder: COLORS.customBorder,

  alert01: COLORS.alert01,
  alert02: COLORS.alert02,
  alert03: COLORS.alert03,
  alert04: COLORS.alert04,

  alertBorder01: COLORS.alertBorder01,
  alertBorder02: COLORS.alertBorder02,
  alertBorder03: COLORS.alertBorder03,
  alertBorder04: COLORS.alertBorder04,

  alertIcon01: COLORS.alertIcon01,
  alertIcon02: COLORS.alertIcon02,
  alertIcon03: COLORS.alertIcon03,
  alertIcon04: COLORS.alertIcon04,

  tablePaginationActiveColor: COLORS.textColor01,

  tag01: COLORS.brand02,
  tag02: COLORS.tag02,
  tag03: COLORS.tag03,

  tagTextColor0: COLORS.brand02,

  tagBackground01: COLORS.tagBackground01,
  tagBackground02: COLORS.tagBackground02,
  tagBackground03: COLORS.tagBackground03,
  tagBackground04: COLORS.tagBackground04,
  tagBackground05: COLORS.tagBackground01,

  tagBorder01: COLORS.tagBorder01,
  tagBorder02: COLORS.tagBorder02,
  tagBorder03: COLORS.tagBorder03,
  tagBorder04: COLORS.tagBorder04,

  yellow: COLORS.yellow,
  black: COLORS.black,
  blackBg: COLORS.blackBg,
  white: COLORS.white,

  rowGreen: COLORS.rowGreen,
  rowRed: COLORS.rowRed,

  brand02Light2: COLORS.brand02Light2,
  brand02Light3: COLORS.brand02Light,

  formItemsBoxShadow: COLORS.formItemsBoxShadow,
  transparent: COLORS.transparent,
  formItemsBoxShadowDefault: COLORS.formItemsBoxShadowDefault,

  orange01: COLORS.orange01,
  orange01Light: COLORS.orange01Light,
  red01: COLORS.orange01Light,
  red01Light: COLORS.orange01Light,

  scroll: COLORS.scroll,
  solitude: COLORS.solitude,
  statusYellow: COLORS.statusYellow,
  statusBrown: COLORS.statusBrown,
  statusGreen: COLORS.statusGreen,
  statusBlue: COLORS.statusBlue,
  statusViolet: COLORS.statusViolet,
  statusRed: COLORS.statusRed,
  statusGray: COLORS.statusGray,
  statusDarkBlue: COLORS.statusDarkBlue,
  statusDarkGreen: COLORS.statusDarkGreen,

  statusBrownLight: COLORS.statusBrownLight,
  statusGreenLight: COLORS.statusGreenLight,
  statusDarkGreenLight: COLORS.statusDarkGreenLight,
  statusBlueLight: COLORS.statusBlueLight,
  statusDarkBlueLight: COLORS.statusDarkBlueLight,
  statusRedLight: COLORS.statusRedLight,
  statusGrayLight: COLORS.statusGrayLight,
  statusVioletLight: COLORS.statusVioletLight,

  borderColor: COLORS.borderColor,

  statusSupportedBg: COLORS.brand02Light,

  statusRealizedColor: COLORS.brand04,
  statusUnsupportedColor: COLORS.brand06,

  dropdownFieldBackground: COLORS.gray02,
  tableHoverBackground: COLORS.gray01,
  timePickerCellBg: COLORS.brand02,
  timePickerCellText: COLORS.textColor03,
  linkColor: COLORS.brand02,
  headerBgColor: COLORS.gray01,
  plannedDocsBg: COLORS.yellow,
  closeBtnBg: COLORS.gray04,
  scrollToTopBtnBg: COLORS.white,
  projectTagBorder: COLORS.transparent,
  scrollShadowBg: COLORS.scrollShadowBgBlack,
  deleteButtonColor: COLORS.brand06,
  deleteButtonBg: COLORS.brand06Light,
};

export const defaultThemeConfig: ThemeConfigType = {
  mobile: {
    components: {
      Button: {
        colorPrimaryActive: '',
        colorPrimaryHover: '',
        colorText: '',
        colorTextLightSolid: '',
        colorBgTextHover: '',
      },
      Pagination: {
        itemSizeSM: -1,
      },
    },
  },
};
